/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Published_AtInputs */

const cs_blog_published_at = /** @type {(inputs: Blog_Published_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno`)
};

const en_blog_published_at = /** @type {(inputs: Blog_Published_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Blog_Published_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_published_at = /** @type {((inputs?: Blog_Published_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Published_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_published_at(inputs)
	return cs_blog_published_at(inputs)
});